/* eslint-disable import/namespace */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
import "../../assets/style/admin/style.css";
import "../../assets/style/admin/all.min.css";
import { RoleForm } from "../../components/admin/role-form";
import { getPermissions, savePermission, loadRole, reset, allActiveRoles } from "../../slices/PermissionsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
export function AddRoles() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.permissions.list);
  const loading = useSelector((state) => state.permissions.loading);
  const params = useParams()
  const roleData = useSelector((state) => state.permissions.roleData);
  const roleList = useSelector((state) => state.permissions.roleList);
  const [roleId, setRoleId] = useState('')
  const [modulePermission, setModulePermission] = useState([])
  const [parentRoleList, setParentRoleList] = useState([])
  
  useEffect(()=>{
    if(params.id){
      setRoleId(params.id)
    }
  },[params.id])

  useEffect( () => {
    dispatch(reset())    
  },[dispatch])

  useEffect(() => {
    dispatch(allActiveRoles()); 
  },[dispatch])

  useEffect(() => {
    dispatch(getPermissions());
  }, [dispatch]);


  //edit
  useEffect( () => {
    if(roleId){
      dispatch(loadRole(roleId))
    }
  },[dispatch, roleId])

  useEffect( () =>{
    let modulePermission = data.map((item) => {
      let hasWebPermission = {
        show: item.webAccess || false,
        selected: false
      }
      let hasAppPermission = {
        show: item.appAccess || false,
        selected: false
      }
      if(typeof roleData !== "undefined" && roleData.hasOwnProperty('permissions')){
          let access = roleData?.permissions?.find( ({permissionId}) => permissionId === item._id )
          console.log(access)
          hasWebPermission.selected = access?.webAccess
          hasAppPermission.selected = access?.appAccess   
      }
      return {
        id: item._id,
        moduleName: item.moduleName,
        showAppAccess: hasAppPermission.show,
        showWebAccess: hasWebPermission.show,
        mobileAccess: hasWebPermission.selected,
        webAccess: hasAppPermission.selected,
      };
    });
    setModulePermission(modulePermission)
    setParentRoleList( () => {
      return roleList.map( (role) => { 
        return {
            value : role._id,
            label: role.name
        }
      })
    } )
   
  },[data, roleData, roleList])
  
  return (
    <React.Fragment>
      <div className="ecommarce-dashboard">
        {loading ? (
          <Loading/>
        ) : (
          <RoleForm savePermission={savePermission} data={{permission:modulePermission, roleData: roleData, parentRoleList}} />
        )}
      </div>
    </React.Fragment>
  );
}
